import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Tutorial } from '../../models/tutorial.model';
import { TutorialService } from '../../services/tutorial.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-tutorial-edit-color',
  templateUrl: './tutorial-edit-color.component.html',
  styleUrls: ['./tutorial-edit-color.component.scss', './../../tutorial.scss']
})
export class TutorialEditColorComponent extends BaseFormComponent<Tutorial> implements OnInit {

  @Input() id: number = null;
  @Output() closeModal = new EventEmitter<void>();
  colors:object[] = [
    {'id':'FCC538','label':'Amarelo'},
    {'id':'C2CC5F','label':'Verde'},
    {'id':'C36C6D','label':'Vermelho'},
    {'id':'9BAECE','label':'Azul céu'},
    {'id':'97D2E3','label':'Azul claro'},
    {'id':'D47900','label':'Laranja'},
    {'id':'E8B9B9','label':'Rosa'},
    {'id':'4CA5BF','label':'Azul turquesa'}
  ];
  constructor(
      public activatedRoute: ActivatedRoute,
      private myService: TutorialService
    ) {
    super(activatedRoute);
   }

  ngOnInit() {
    this.initForm();
    this.loaded();
  }
  
  initForm(): void {
    this.form = new FormGroup({
      color: new FormControl(null, [Validators.required])
    });
  }


  getDataCreate(): object {
    return Object.assign({}, this.form.value);
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.update(this.getDataCreate(), this.id).subscribe({
          next: (res) => {
            this.confirmation("Tutorial salvo com sucesso!").subscribe(() => {
              window.location.reload();
            })
            this.loaded();
          },
          error: (error) => {
            let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
            this.msgError(msg);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  onCloseModal(): void{
    this.closeModal.emit();
  }

}
